import { useGestionAccess } from "hooks/useGestionAccess";

/**
 * Renders its children only when the user has the Finanzas area of the current Gestión customer.
 * A component (not a hook) so it can wrap JSX inside table cell renderers.
 */
const FinanceOnly = ({ children }) => {
  const { can } = useGestionAccess();
  return can("finance") ? children : null;
};

export default FinanceOnly;
